import { fromJS } from 'immutable'
import * as types from './actionTypes'
import moment from 'moment'

export const organizationHolidaysState = fromJS({
  orgId: null,
  holidays: [],
  pending: false,
})

export default (state = organizationHolidaysState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.HOLIDAY_LIST_SET_PENDING: {
      return state.set('pending', payload.pending)
    }
    case types.HOLIDAYS_LIST.GET.SUCCESS: {
      const { data: { holidays, orgId } } = payload
      return state
        .set(
          'holidays',
          fromJS(
            holidays.map(({ name, startDate, endDate }) => {
              return {
                name,
                startDate: moment(startDate).utc(),
                endDate: moment(endDate).utc(),
              }
            })
          )
        )
        .set('orgId', orgId)
    }
  }
  return state
}
